import { observer } from "mobx-react";
import GlobalView from "pages/GlobalView/GlobalView";
import LaneView from "pages/LaneView/LaneView";
import { RouteView } from "pages/RouteView/RouteView";
import { ShipmentView } from "pages/ShipmentView/ShipmentView";
import React, { useEffect } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { useStore } from "store/StoreConfigs";

function LrmModule() {
    const { commonStore, filtersStore } = useStore();
    const history = useHistory();

    useEffect(() => {
        commonStore.setSelectedTab(0);
        filtersStore.setModule("Lrm");
    }, []);
    return (
        <Switch>
            <Route path="/lrm/lanes/:laneId/routes/:routeId/shipments/:shipmentId">
                <ShipmentView />
            </Route>
            <Route path="/lrm/lanes/:laneId/routes/:routeId">
                <RouteView />
            </Route>
            <Route path="/lrm/lanes/:laneId">
                <LaneView />
            </Route>
            <Route exact path="/lrm">
                <GlobalView />
            </Route>
            <Route path="*">{() => history.push("/lrm")}</Route>
        </Switch>
    );
}
export default observer(LrmModule);
